export default __webpack_public_path__ + "../img/d0f29527b6d3114ebbd2b576e1b1e95a.png";